import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\UnlinkDossierPaymentController::__invoke
* @see app/Http/Controllers/Dossier/UnlinkDossierPaymentController.php
* @route '/api/dossier/{dossier}/payment/{payment}/unlink'
*/
const UnlinkDossierPaymentController = (args: { dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UnlinkDossierPaymentController.url(args, options),
    method: 'post',
})

UnlinkDossierPaymentController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/payment/{payment}/unlink',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\UnlinkDossierPaymentController::__invoke
* @see app/Http/Controllers/Dossier/UnlinkDossierPaymentController.php
* @route '/api/dossier/{dossier}/payment/{payment}/unlink'
*/
UnlinkDossierPaymentController.url = (args: { dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            payment: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        payment: typeof args.payment === 'object'
        ? args.payment.id
        : args.payment,
    }

    return UnlinkDossierPaymentController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{payment}', parsedArgs.payment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\UnlinkDossierPaymentController::__invoke
* @see app/Http/Controllers/Dossier/UnlinkDossierPaymentController.php
* @route '/api/dossier/{dossier}/payment/{payment}/unlink'
*/
UnlinkDossierPaymentController.post = (args: { dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UnlinkDossierPaymentController.url(args, options),
    method: 'post',
})

export default UnlinkDossierPaymentController